/**
 * Заменяет TMainForm.vue и предоставляет общую структуру для всех 20+ форм.
 *
 * Предоставляет:
 * - propertyColumnVisible — колонки таблицы свойств
 * - getStylePropertyTable / getStyleLogs — стили позиционирования
 * - facilityChanged — обработчик события обновления
 * - setupFormLifecycle — настройка lifecycle (mounted/beforeUnmount)
 */
import { ref, computed } from 'vue';
import EventBus from '@/core/EventBus';
import { useStore } from 'vuex';

// Колонки по умолчанию для PropertyTable
export const DEFAULT_PROPERTY_COLUMNS = [
  'id',
  'flangeNo',
  'typeName',
  'desc',
  'rules',
  'value',
  'unitShortName',
  'outputValue',
  'outputValueText',
  'date',
  'event',
];

export function useScadaForm(options = {}) {
  const {
    onFacilityChanged = null, // callback при обновлении facility
    onMounted = null, // callback при mounted
    onUnmounted = null, // callback при beforeUnmount
  } = options;

  const store = useStore();

  // Колонки таблицы свойств
  const propertyColumnVisible = ref([...DEFAULT_PROPERTY_COLUMNS]);

  // Стили позиционирования
  const getStylePropertyTable = computed(() => {
    const width = !store.getters.maxY ? 455 : store.getters.maxY + 100;
    return {
      position: 'absolute',
      top: `${width}px`,
    };
  });

  const getStyleLogs = computed(() => {
    const height =
      !store.getters.maxY || store.getters.maxY < 370
        ? 455
        : store.getters.maxY + 100;
    return {
      top: `${height}px`,
    };
  });

  // Обработчик обновления facility
  function facilityChanged(facility) {
    if (onFacilityChanged) {
      onFacilityChanged(facility);
    }
  }

  // Настройка lifecycle
  function setupFormLifecycle() {
    // Вызывается из mounted()
    function onMountedHandler() {
      EventBus.on('on-first-property-update', facilityChanged);

      if (onMounted) {
        onMounted();
      }
    }

    // Вызывается из beforeUnmount()
    function onBeforeUnmountHandler() {
      EventBus.off('on-first-property-update');

      if (onUnmounted) {
        onUnmounted();
      }
    }

    return { onMountedHandler, onBeforeUnmountHandler };
  }

  return {
    // Данные
    propertyColumnVisible,

    // Вычисляемые свойства
    getStylePropertyTable,
    getStyleLogs,

    // Методы
    facilityChanged,
    setupFormLifecycle,
  };
}
